import React from "react"

interface ExpensePropertyDisplayProps {
    title: string
    value: string
    children?: React.ReactNode
    className?: string
}
export const ExpensePropertyDisplay = ({ title, value, children, className }: ExpensePropertyDisplayProps) => (
    <div className={className}>
        <div>{title}</div>
        <div className="flex justify-start h-32 items-center">
            <div className="leading-tight truncate text-base font-medium">{children ?? value}</div>
        </div>
    </div>
)
